import axios from "axios";

const getCierreAnterior = async idCaja => {
  const formattedNic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");

  const userData = {
    nic: formattedNic,
    token: token,
    idCaja: idCaja,
    serialNumberKeyClover: localStorage.getItem("serialNumberKeyClover"),
  };
  const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/CierreDeTurno/GetCierreAnterior`, userData);
  return response.data;
};

const cierreAnterior = {
  getCierreAnterior,
};

export default cierreAnterior;
